import React, { useEffect, useState } from "react";
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import Slider from '@mui/material/Slider';
import Box from '@mui/material/Box';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Snackbar from '@mui/material/Snackbar';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { db, firebase_update_device_setting} from "../firebase";

const styles = {
  dial: {
    width: `auto`,
    height: `auto`,
    color: "#000",
    border: "0.5px solid #fff",
    padding: "2px"
  },
  title: {
    fontSize: "1em",
    color: "#000"
  }
};

const PressureSetting = ({ deviceId, id, hardware_status, max_rate, max_value, min_value }) => {
    const [maxRateValue, setMaxRateValue] = useState(max_rate);
    const [maxValue, setMaxValue] = useState(max_value);
    const [minValue, setMinValue] = useState(min_value);
    const [hardwareInstall, setHardwareInstall] = useState(hardware_status=='installed');
    const [openChangeSnackbar, setOpenChangeSnackbar] = useState(false);
    const [changeMessage, setChangeMessage] = useState();

    var createNestedObject = function( base, names, value ) {
        // If a value is given, remove the last name and keep it for later:
        var lastName = arguments.length === 3 ? names.pop() : false;
    
        // Walk the hierarchy, creating new objects where needed.
        // If the lastName was removed, then the last object is not set yet:
        for( var i = 0; i < names.length; i++ ) {
            base = base[ names[i] ] = base[ names[i] ] || {};
        }
    
        // If a value was given, set it to the last name:
        if( lastName ) base = base[ lastName ] = value;
    
        // Return the last object in the hierarchy:
        return base;
    };

    useEffect(() => {
        setMaxRateValue(max_rate);
        setMaxValue(max_value);
        setMinValue(min_value);
        setHardwareInstall(hardware_status=='installed');     
    }, [hardware_status, max_rate, max_value]);

    const handleMaxRateChange = (event, newValue) => {
        if (typeof newValue === 'number') {
        setMaxRateValue(newValue);
        }
    };

    const handleMaxRateUpdateFirebase = (event, newValue) => {
        if (typeof newValue === 'number') {
            firebase_update_device_setting(deviceId + '/sensor_info/pressure/' + id + '/max_rate', newValue.toString());
            setMaxRateValue(newValue);      
            setChangeMessage("Change pressure max rate to " + newValue + " psi/min"); 
            setOpenChangeSnackbar(true);          
        }
    };

    const handleMaxValueChange = (event, newValue) => {
        if (typeof newValue === 'number') {
            setMaxValue(newValue);
        }
    };

    const handleMaxValueUpdateFirebase = (event, newValue) => {
        if (typeof newValue === 'number') {
            firebase_update_device_setting(deviceId + '/sensor_info/pressure/' + id + '/max_value', newValue.toString());
            setMaxValue(newValue);            
            setChangeMessage("Change pressure max value to " + newValue + " psi"); 
            setOpenChangeSnackbar(true);          
        }
    };

    const handleMinValueChange = (event, newValue) => {
      if (typeof newValue === 'number') {
          setMinValue(newValue);
      }
  };

  const handleMinValueUpdateFirebase = (event, newValue) => {
      if (typeof newValue === 'number') {
          firebase_update_device_setting(deviceId + '/sensor_info/pressure/' + id + '/min_value', newValue.toString());
          setMinValue(newValue);            
          setChangeMessage("Change pressure min value to " + newValue + " psi"); 
          setOpenChangeSnackbar(true);          
      }
  };

    const handleHardwareInstallChange = (event) => {
        if(event.target.checked)
        {
            firebase_update_device_setting(deviceId + '/sensor_info/pressure/' + id + '/hardware_status', "installed");
            setChangeMessage("Pressure sensor hardware has been installed.")
        }
        else
        {
            firebase_update_device_setting(deviceId + '/sensor_info/pressure/' + id + '/hardware_status', "not_installed");
            setChangeMessage("Pressure sensor hardware has not been installed.")
        }
        setHardwareInstall(event.target.checked);
        setOpenChangeSnackbar(true);
    }

    const handleCloseChangeMessageSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpenChangeSnackbar(false);
      };

    return (
            <Stack direction="column" sx={{width: "100%"}}>       
                <Box sx={{ pb: 3}}>
                <FormGroup>
                    <FormControlLabel control={<Switch disabled={sessionStorage.getItem('power_user')=="false"} checked={hardwareInstall} />} label={hardwareInstall ? "Installed" : "Not Installed"} onChange={handleHardwareInstallChange} />
                </FormGroup>
                </Box>                       
                <Box sx={{ width: "100%" }}>
                  <Typography gutterBottom variant="caption">
                      Max Pressure Rate: {maxRateValue} psi/min
                    </Typography>
                  <Slider 
                    disabled={(hardwareInstall==false) || (sessionStorage.getItem('power_user')=="false")}
                    value={maxRateValue} 
                    min={10}
                    max={40}
                    onChange={handleMaxRateChange}
                    onChangeCommitted={handleMaxRateUpdateFirebase}
                    aria-label="Max rate slider" />
                </Box>
                <Box sx={{ width: "100%" }}>
                  <Typography gutterBottom variant="caption">Max Pressure Value: {maxValue} psi</Typography>
                  <Slider                   
                    disabled={(hardwareInstall==false) || (sessionStorage.getItem('power_user')=="false")}
                    value={maxValue} 
                    min={100}
                    max={200}
                    onChange={handleMaxValueChange}
                    onChangeCommitted={handleMaxValueUpdateFirebase}
                    aria-label="Max value slider" />
                </Box>
                <Box sx={{ width: "100%" }}>
                  <Typography gutterBottom variant="caption">Min Pressure Value: {minValue} psi</Typography>
                  <Slider                   
                    disabled={(hardwareInstall==false) || (sessionStorage.getItem('power_user')=="false")}
                    value={minValue} 
                    min={0}
                    max={100}
                    onChange={handleMinValueChange}
                    onChangeCommitted={handleMinValueUpdateFirebase}
                    aria-label="Min value slider" />
                </Box>
                <Snackbar
                  open={openChangeSnackbar}
                  autoHideDuration={6000}
                  onClose={handleCloseChangeMessageSnackbar}
                  message={changeMessage}
                /> 
            </Stack>
  );
};

export default PressureSetting;
